import {
  Box,
  Button,
  Popover,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  IEcommerceProductHierarchy,
  IEcommerceProductHierarchyItem
} from 'src/models/ecommerce';
import useEcommerce from 'src/services/useEcommerce';
import FilterBrandList from './FilterBrandList';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';
import FloatingLabelButton from '../FloatingLabelButton';

export default function FilterBrand() {
  const theme = useTheme();
  const { selectedOriginalToPost, selectedBrand } = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const { objectListByObjectType } = useAppSelector(
    (state) => state.objectManagement
  );
  const [openBrand, setOpenBrand] = useState<boolean>(false);
  const [anchorElBrand, setAnchorElBrand] = useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();

  const projectId = useAppSelector((state) => state.users.project.id);
  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const { useGetEcommerceStreamCommentingToProduct } = useEcommerce();

  const {
    data: streamsCommentingToPostData,
    loading: loadingStreamsCommentingToPost
  } = useGetEcommerceStreamCommentingToProduct({
    skip: !openBrand,
    variables: {
      projectId: projectId,
      objectIds: objectListByObjectType.map((item) => item.id)
    },
    fetchPolicy: 'network-only'
  });

  const [selectedBrandLocal, setSelectedBrandLocal] =
    useState<IEcommerceProductHierarchy[]>(selectedBrand);
  const [
    selectedCommentingToProductsLocal,
    setSelectedCommentingToProductsLocal
  ] = useState<IEcommerceProductHierarchyItem[]>(selectedOriginalToPost);

  const handleOpenBrand = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElBrand(event.currentTarget);
    setOpenBrand(true);
  };

  const handleCloseBrand = () => {
    setAnchorElBrand(null);
    setOpenBrand(false);
  };

  const handleApply = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        replyToOriginalId: selectedCommentingToProductsLocal.map(
          (stream) => stream.originalId
        ),
        selectedOriginalToPost: selectedCommentingToProductsLocal,
        selectedBrand: selectedBrandLocal,
        selectedSubBrand: selectedBrandLocal.flatMap((item) => item.subBrands)
      })
    );
    handleCloseBrand();
  };

  useEffect(() => {
    setSelectedBrandLocal(selectedBrand);
    setSelectedCommentingToProductsLocal(selectedOriginalToPost);
  }, [selectedOriginalToPost, selectedBrand]);

  return (
    <>
      <Stack maxWidth="400px" width="100%">
        <FloatingLabelButton
          chipList={selectedBrand.map((item) => item.name)}
          label="Brand"
          onClick={handleOpenBrand}
          open={openBrand}
        />
      </Stack>
      <Popover
        open={openBrand}
        onClose={handleCloseBrand}
        anchorEl={anchorElBrand}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: theme.spacing(2), maxWidth: '600px', width: '100%' }}>
          <Typography variant="h4">Brand</Typography>
          <FilterBrandList
            data={
              streamsCommentingToPostData?.ecommerceProductManagement_getProductHierarchy ||
              []
            }
            loading={loadingStreamsCommentingToPost}
            selectedProducts={selectedCommentingToProductsLocal}
            onSelectedProductsChange={(
              products: IEcommerceProductHierarchyItem[]
            ) => {
              setSelectedCommentingToProductsLocal(products);
            }}
            selectedBrand={selectedBrandLocal}
            setSelectedBrand={setSelectedBrandLocal}
          />
          <Stack pt={1} alignItems="end">
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
